import React from 'react';
import Icon, { ICONS, COLORS } from '../../general-components/icon';
import * as l from './effects/elements';
import useUserActions from '../../../hooks/use-user-actions';
import tellysmiling from '../../../images/telly-transitions/telly-smiling.svg';
import {ReactComponent as Tellymagic} from '../../../images/telly-magic.svg';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';

interface OwnProps {
    style?: React.CSSProperties;
}

export default function CameraOff(props: OwnProps) {
    const {style = {} } = props;
    const { use_pixel: usePixel } = useSelector((state: GreenroomState) => state.SettingsReducer.featureFlags);
	const { toggleVideo } = useUserActions();
	return (<div style={{...l.FullWidthStyle, ...style}}>
        {usePixel
            ? <Tellymagic className='icon pale-green position-absolute' style={{right: 0, bottom: 0, opacity: 0.5, height: '30%'}}/>
            : <l.NoVideoTelly src={tellysmiling} alt='telly-smiling' />
        }
        <div style={{ zIndex: 1 }}>
            <div className='bl-font-s1 text-gray-200 text-align-center' >
                Your camera is turned off
            </div>
            <l.BigGradientButton
                className='bl-font-l1 text-gray-1200 button-background-shading button-pillbox sherbert'
                onClick={() => toggleVideo()}
            >
                <Icon name={ICONS.CAMERA_ON} size={12} color={COLORS.TEXT_GRAY_300} />
                <span className='margin-left-small'>Enable for Preview</span>
            </l.BigGradientButton>
        </div>
    </div>);
}
